const IpromoteAdaptor = (adaptorPayload) => {

  // Ipromote works by receiving an event, packaging it into a URL, and then appending it to the body.

  const eventIdMap = {
    'link-homepage': 1,
    'link-email': 2,
    'link-call': 3,
    'link-facebook': 4,
    'link-twitter': 5,
    'form-submit': 15,
    'map-user-interact': 16,
    'coupon-redeem': 7,
    'coupon-email': 8,
    'coupon-sms': 9,
    'coupon-print': 10,
    'coupon-share': 11,
    'coupon-share-facebook': 12,
    'coupon-share-twitter': 13,
    'map-get-directions': 16
  }

  const conversionEvents = ['form-submit','link-call'];

  // This function is part of backend/utils.coffee in old adaptor_ipromote.coffee file
  const parseUrl = (utmSource) => {
    let index, items, result, tmp;
    result = null;
    tmp = [];
    items = location.search.substr(1).split('&');
    index = 0;
    while (index < items.length) {
      tmp = items[index].split('=');
      if (tmp[0] === utmSource) {
        result = tmp[1];
      }
      index++;
    }
    return result;
  }

  let campaignId;
  if ( window.sb.siteInfo['partner_site_id'] ) {
    campaignId = window.sb.siteInfo['partner_site_id'];
  } else if ( window.sb.siteInfo['partner_proxy_id'] ) {
    campaignId = window.sb.siteInfo['partner_proxy_id'];
  }

  const source = parseUrl('utm_source')

  const addTrackingImage = (url) => {
    // https://stackoverflow.com/questions/11515383/why-is-element-innerhtml-bad-code
    document.body.insertAdjacentHTML('beforeend', "<img src='" + url + "' width='0' height='0' border='0' />")
  }

  const trackEvent = (eventId, eventType) => {
    // Conversion events are supposed to appended twice, once as an event, once as converision
    // This is why a nested if is used instead of an if - else structure.

    // Event Type:
    // 98: normal event
    // 99: conversion event
   
    let url = "https://i.ipromote.com/ad/?typ=#{eventType}";
    url = "https://i.ipromote.com/ad/?typ=" + eventType;
    if (source) {
      url += "&source=" + source;
    } else {
      url += "&source=Other";
    }
    url += "&event=" + eventId + "&cid=" + campaignId;
    return addTrackingImage(url);
  }

  if (eventIdMap[adaptorPayload.analyticsEvent.name]) {
    let eventId = eventIdMap[adaptorPayload.analyticsEvent.name];
    trackEvent( eventId, 98 );

    if (conversionEvents.includes(adaptorPayload.analyticsEvent.name)){
      trackEvent( eventId, 99 );
    }
    
  } 
  
}

export { IpromoteAdaptor }